import { SubtractiveGenerator } from 'game-logic';
import { RoundGroup } from './models/round-group';
import { Shape } from './models/shape';
import { DataImporter } from './data/data-importer';
import { GameMetricsType } from './helpers/game-metrics';

export class ShapeBoard {
  public currentShapes: Shape[] = [];

  private shapePool: Shape[];
  private roundGroups: RoundGroup[];

  constructor(private gameMetrics: GameMetricsType) {
    this.shapePool = DataImporter.importShapes();
    this.roundGroups = DataImporter.importRoundGroups();
  }

  public showNextThreeShapes(random: SubtractiveGenerator, round: number) {
    const currentRoundGroup = this.roundGroups.find(
      (group) => round >= group.minRound && round <= group.maxRound,
    );
    if (!currentRoundGroup) {
      throw new Error('Round group not found');
    }

    const availableShapesBasedOnRound: Shape[] = this.shapePool.filter((shape) => {
      return currentRoundGroup.shapesNums.some((item) => item === shape.shapeNum);
    });
    if (availableShapesBasedOnRound.length === 0) {
      throw new Error('Not found any shape');
    }

    const currentShapes: Shape[] = [];

    for (let i = 0; i < this.gameMetrics.GameShapeCount; i++) {
      let randomShape =
        availableShapesBasedOnRound[random.next() % availableShapesBasedOnRound.length];

      while (currentShapes.some((item) => item.shapeNum === randomShape.shapeNum)) {
        randomShape =
          availableShapesBasedOnRound[random.next() % availableShapesBasedOnRound.length];
      }

      currentShapes.push(randomShape.cloneShape());
    }

    const randomShapeForMultiplier = currentShapes[random.next() % currentShapes.length];
    const randomBlockForMultiplier =
      randomShapeForMultiplier.blocks[random.next() % randomShapeForMultiplier.blocks.length];
    randomBlockForMultiplier.multiplier = 1;

    this.currentShapes = currentShapes;
  }
}
